<template>
    <div class="us-form-div">
        <kontakt v-if="current=='Kontakt'"></kontakt>
        <busanmietung v-if="current=='Busanmietung'"></busanmietung>
        <gruppen v-if="current=='Gruppen'"></gruppen>
        <klassen v-if="current=='Klassen'"></klassen>
        <kataloganfordern v-if="current=='Kataloganfordern'"></kataloganfordern>
        <gutschein v-if="current=='Gutschein'"></gutschein>
    </div>
</template>

<script>
import Kontakt from "./formulare/Kontakt"
import Busanmietung from "./formulare/Busanmietung"
import Gruppen from "./formulare/Gruppen"
import Klassen from "./formulare/Klassen"
import Kataloganfordern from "./formulare/Kataloganfordern"
import Gutschein from "./formulare/Gutschein"

export default {
    data() {
        return {
            current: null
        }
    },
    components: {
        Kontakt,
        Busanmietung,
        Gruppen,
        Klassen,
        Kataloganfordern,
        Gutschein    
    },
    watch: {
        $route(to, from) {
            let args = core.getPathArgs(["id"])
            this.current = args.id

        }
    },
    mounted() {
        
        let args = core.getPathArgs(["id"])
        this.current = args.id
    }
}
</script>

<style lang="scss" scoped>
.us-form-div{
    padding: 20px 50px;
    color: #555;
}
</style>